<section class="page">
    <div class="page-wrapper">
        <div class="page-header">
            <h1 class="page-title">
                Leads
            </h1>
        </div>

        <div class="page-table">

            <div class="page-table-container">
                <div class="loading-shade" *ngIf="!isLoadingResults && !data.length">
                    <div class="rate-limit-reached">
                        Nenhum registro encontrado
                    </div>
                </div>

                <div class="loading-shade" *ngIf="isLoadingResults">
                    <mat-spinner></mat-spinner>
                </div>

                <table mat-table [dataSource]="data">

                    <ng-container matColumnDef="1">
                        <th mat-header-cell *matHeaderCellDef>
                            Data hora
                        </th>
                        <td mat-cell *matCellDef="let row">{{helper.moment(row.dataHora).format('DD/MM/YYYY HH:mm')}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="2">
                        <th mat-header-cell *matHeaderCellDef>Nome</th>
                        <td mat-cell *matCellDef="let row">{{row.usuarioApp.nome}}</td>
                    </ng-container>

                    <ng-container matColumnDef="3">
                        <th mat-header-cell *matHeaderCellDef>E-mail</th>
                        <td mat-cell *matCellDef="let row">{{row.usuarioApp.email}}</td>
                    </ng-container>

                    <ng-container matColumnDef="4">
                        <th mat-header-cell *matHeaderCellDef>Celular</th>
                        <td mat-cell *matCellDef="let row">
                            <a [href]="'https://wa.me/55'+row.usuarioApp.celular">
                                {{row.usuarioApp.celular | mask: '(00) 00000-0000'}}
                            </a>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="5">
                        <th mat-header-cell *matHeaderCellDef>Tipo</th>
                        <td mat-cell *matCellDef="let row">
                            {{row.tipo === 'CLICKS' ? 'Clicks' : ''}}
                            {{row.tipo === 'CONTATOS' ? 'Contatos' : ''}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <!-- <a mat-icon-button mat-button matTooltip="Editar" aria-label="Editar" color="primary"
                                    [routerLink]="['/admin/planos/editar', row.id]">
                                    <mat-icon>create</mat-icon>
                                </a> -->
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <mat-paginator [length]="resultsLength" [pageSizeOptions]="[15, 25, 40, 50]" [pageSize]="15">
                </mat-paginator>
            </div>
        </div>
    </div>
</section>